import { render, staticRenderFns } from "./second.vue?vue&type=template&id=c9b482a6&"
import script from "./second.vue?vue&type=script&lang=js&"
export * from "./second.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports